// @flow

import * as React from "react"
import {connect} from "react-redux"
import Config from "../../../config"
import {withTranslation} from "react-i18next"
import {
  publishShopItems,
  unpublishShopItems,
  deleteShopItems,
  selectAllShopItems,
} from "../../../actions/shop"
import type {Dispatch, State as ReduxState} from "../../../types"

type Props = {
  t: any,
  dispatch: Dispatch,
  selectedShopItems: $ReadOnlyArray<number>,
}

type BulkActionType = "" | "publish" | "unpublish" | "delete"

type State = {
  selectedBulkAction: BulkActionType,
}

class ShopAdminItemListActions extends React.Component<Props, State> {
  handleBulkActionApply: () => void
  handleBulkActionChange: (SyntheticInputEvent<HTMLSelectElement>) => void
  handleSelectAll: (SyntheticMouseEvent<HTMLLinkElement>) => void

  constructor(props: Props) {
    super(props)
    this.handleBulkActionApply = this.handleBulkActionApply.bind(this)
    this.handleBulkActionChange = this.handleBulkActionChange.bind(this)
    this.handleSelectAll = this.handleSelectAll.bind(this)
    this.state = {selectedBulkAction: ""}
  }

  handleBulkActionChange(e: SyntheticInputEvent<HTMLSelectElement>) {
    let selectedBulkAction = ""
    switch (e.currentTarget.value) {
      case "publish":
        selectedBulkAction = "publish"
        break
      case "unpublish":
        selectedBulkAction = "unpublish"
        break
      case "delete":
        selectedBulkAction = "delete"
        break
    }
    this.setState({selectedBulkAction})
  }

  handleBulkActionApply() {
    const {selectedShopItems, dispatch} = this.props
    switch (this.state.selectedBulkAction) {
      case "publish":
        return dispatch(
          publishShopItems(Config.data.babyToken, selectedShopItems)
        )
      case "unpublish":
        return dispatch(
          unpublishShopItems(Config.data.babyToken, selectedShopItems)
        )
      case "delete":
        return dispatch(
          deleteShopItems(Config.data.babyToken, selectedShopItems)
        )
      default:
        return null
    }
  }

  handleSelectAll(e: SyntheticMouseEvent<HTMLLinkElement>) {
    e.preventDefault()
    this.props.dispatch(selectAllShopItems())
  }

  renderBulkActionSection() {
    const {t} = this.props
    return (
      <div className="d-flex align-items-center mb-4">
        <select
          value={this.state.selectedBulkAction}
          className="form-control w-25"
          onChange={this.handleBulkActionChange}
        >
          <option value="">{t("shopAdmin.listActions.actions")}</option>
          <option value="publish">{t("publish")}</option>
          <option value="unpublish">{t("unpublish")}</option>
          <option value="delete">{t("delete")}</option>
        </select>
        <button
          className="btn btn-outline-primary ml-2"
          onClick={this.handleBulkActionApply}
        >
          {t("shopAdmin.listActions.apply")}
        </button>
        <a
          className="btn btn-link ml-2"
          href="#"
          onClick={this.handleSelectAll}
        >
          {t("shopAdmin.listActions.selectAll")}
        </a>
      </div>
    )
  }
  render() {
    return (
      <div className="shop-admin-item-list-actions">
        {this.renderBulkActionSection()}
      </div>
    )
  }
}

const mapStateToProps = (state: ReduxState) => ({
  selectedShopItems: state.shop.selectedShopItems,
})

export default withTranslation()(
  connect(mapStateToProps)(ShopAdminItemListActions)
)
